import React from 'react';
import { ISpuInfo, IReview } from 'base/interfaces/product';
import { IFeedSpuInfo } from 'base/interfaces/diyPools';
import { useStoreState } from 'base/store';
import { getMainPicUrl } from 'base/utils/getPicUrl';
import site from 'pro/config/site';
import { useRouter } from 'next/router';
import { transLocalTime } from 'base/utils/date';
import Script from 'next/script';
import { getTrackerSkuPrefix } from 'base/utils/product';

type ProdSchemaProps = {
    spuInfo: ISpuInfo | IFeedSpuInfo;
    reviewInfo: IReview;
};

const ProdSchema: React.FC<ProdSchemaProps> = ({ spuInfo, reviewInfo }) => {
    const router = useRouter();
    const { host, currency, country } = useStoreState('rootStore');
    const skuPrefix = getTrackerSkuPrefix(country);

    const schema = spuInfo?.productVariants?.map(v => {
        const data = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "image": getMainPicUrl(v?.pics || [], v.productVariantId) || site.errorImage,
            "name": v.name,
            "description": v.desc,
            "sku": skuPrefix + v.productId + ":" + v.productVariantId,
            "inProductGroupWithID": "" + v.productId,
            "brand": {
                "@type": "Brand",
                "name": site.brand
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": Number(reviewInfo?.score) || 4.5,
                "reviewCount": Number(reviewInfo?.reviewNum) || 0
            },
            "offers": {
                "@type": "Offer",
                "url": `${host.indexOf('localhost') === -1 ? 'https' : 'http'}://${host}${router.asPath.replace(/\?.*/, '')}`,
                "itemCondition": "https://schema.org/NewCondition",
                "availability": `https://schema.org/${v.productTagsVoList.find(tag => tag.tag === 'presale') ? 'PreOrder' : `${v.isOnSale > 0 && v.stockNum > 0 ? 'InStock' : 'OutOfStock'}`}`,
                "price": Number(v.dealPriceExchange) > 0 ? v.dealPriceExchange : v.shopPriceExchange,
                "priceValidUntil": transLocalTime(Date.now() + 86400000 * 20, 'isoDate'),
                "priceCurrency": currency
            }
        };
        return data;
    });

    return (
        <Script
            id={`prod-schema-${spuInfo.id}`}
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema)
            }}
        />
    )
};

export default ProdSchema;
